import React from "react";
import style from "./index.module.scss";
import { Button, Divider, message, Modal, Tooltip } from "antd";
import {
    cancelCloudDesk,
    ExperiListItem,
    goToExperimentUrl,
    removeCloudDeskTop
} from "service/experiment";
import usePromiseCallback from "utils/usePromiseCallback";
import { errorMessage } from "service/service";
import moment from "moment";
import Status from "./components/Status";

interface ListItemProps {
    data: ExperiListItem;
    weekTimeId: number;
    onChange: () => void;
}

export default function ListItem({
    data,
    weekTimeId,
    onChange
}: ListItemProps) {
    //前往实验
    function gotoExperiment(url: string) {
        if (data.useStatus !== "1") {
            message.error("尚未到达预约实验的开始时间");
        } else {
            goToExperimentUrl(url);
        }
    }

    //删除预约
    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            getContainer,
            title: `确认删除“${data.name}”吗？`,
            content: "实验计划删除后不可恢复，确定要删除吗？",
            onOk: async () => {
                try {
                    await removeCloudDeskTop(data.id);
                    message.success("删除成功!");
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    //取消预约
    const onCancel = usePromiseCallback(async function () {
        Modal.confirm({
            getContainer,
            title: `确认取消预约“${data.name}”？`,
            content: `预约取消后，系统将会删除“${data.name}”，确定要取消预约吗？`,
            onOk: async () => {
                try {
                    await cancelCloudDesk(weekTimeId, String(data.id));
                    message.success("取消成功!");
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });

    function getContainer(): any {
        return document.querySelector(".PopupContainer");
    }

    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={data.name}>{data.name}</Tooltip>

                <Status status={parseInt(data.useStatus)} />
            </h1>

            <div className={style.info}>
                实验项目 {data.projectName}
                <Divider type="vertical" style={{ background: "#aaa" }} />
                预约数量 {data.useCount}
                <Divider type="vertical" style={{ background: "#aaa" }} />
                实验时间 {moment(data.beginTime).format("MM-DD HH:mm")} ~{" "}
                {moment(data.endTime).format("MM-DD HH:mm")}
            </div>

            {/*0:未开始， 1:进行中， 2:已结束*/}
            <div className={style.tools}>
                {data.useStatus === "2" && (
                    <Button type="link" onClick={onDelete}>
                        删除
                    </Button>
                )}
                {data.useStatus !== "2" && (
                    <Button
                        type="link"
                        onClick={() => gotoExperiment(data.url)}>
                        前往实验
                    </Button>
                )}
                {data.useStatus === "0" && (
                    <Button type="link" onClick={onCancel}>
                        取消预约
                    </Button>
                )}
            </div>
        </div>
    );
}
